const domain = window.location.origin
const env = {
    development: {
        API_BASE_URL: "https://touch.viessmann.com.tr/"
    },
    integration: {
        API_BASE_URL: `${domain}/`
    },
    staging: {
        API_BASE_URL: `${domain}/`
    },
    production: {
        API_BASE_URL: `${domain}/`
    }
}


export default env.production